var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ローディング
import {loading} from "../include/module";
loading();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// アニメーション
import {animationFire} from "../include/module";
animationFire();

// YouTubeのモーダル
import {youtubeModal} from "../include/module";
youtubeModal();

// ページ下部のキャラランダム表示
import {bottomCharaRandom} from "../include/module";
bottomCharaRandom();


const setCookie = () =>{
  if (!$.cookie('modal')) {
    $.cookie('modal', 1, {expires: 3});
  }
};
if($.cookie("modal")){}else{
  var $modalAfterLoad = $(".modal-AfterLoad");
  $modalAfterLoad.click();
  setCookie();
}



// WEBPACK FOOTER //
// script.js